import { SxProps, Theme } from '@mui/material';

export const FallbackUIMainStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  paddingTop: theme => theme.spacing(12),
  paddingBottom: theme => theme.spacing(4),
  overflow: 'hidden',
};

export const FallbackUIPaperStyles: SxProps<Theme> = {
  padding: theme => theme.spacing(4),
  borderRadius: theme => theme.spacing(0.75),
  boxShadow: theme => theme.variables.boxShadowMenu,
};

export const FallbackUIMessageStyles: SxProps<Theme> = {
  fontSize: 20,
  marginBottom: theme => theme.spacing(2),
};

export const FallbackUITitleStyles: SxProps<Theme> = {
  fontSize: 24,
  display: 'flex',
  justifyContent: 'center',
  '& svg': {
    fontSize: theme => theme.spacing(4.5),
    alignSelf: 'center',
    marginRight: theme => theme.spacing(1.5),
    '& path': {
      fill: theme => theme.colors.redPink,
    },
  },
};

export const FallbackUISeparatorStyles: SxProps<Theme> = {
  width: '100%',
  height: 2,
  opacity: 0.7,
  backgroundColor: theme => theme.colors.silver,
  marginTop: theme => theme.spacing(3),
  marginBottom: theme => theme.spacing(3),
};

export const FallbackUIInstructionStyles: SxProps<Theme> = {
  display: 'flex',
  marginTop: theme => theme.spacing(4),
  fontSize: theme => theme.spacing(1.75),
  alignItems: 'center',
  '& svg': {
    fontSize: theme => theme.spacing(6),
    marginLeft: -10,
    marginRight: theme => theme.spacing(0.5),
    marginTop: 2,
    '& path': {
      stroke: 'white',
      fill: theme => theme.colors.darkSkyBlue,
    },
  },
};
